"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = DiscoverDrawer;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const drawer_1 = require("@react-navigation/drawer");
const react_redux_1 = require("react-redux");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const store_1 = require("../store");
const user_1 = require("../store/selectors/user");
const useAppState_1 = require("../hooks/useAppState");
const AllCharacterList_1 = __importDefault(require("../screen/AllCharacterList"));
const Documents_1 = __importDefault(require("../screen/Discover/Documents"));
const Library_1 = __importDefault(require("../screen/Discover/Library"));
const DiscoverProfile_1 = require("../screen/Discover/DiscoverProfile");
const AppButton_1 = require("../component/AppButton");
const AppText_1 = require("../component/AppText");
const colors_1 = require("../common/colors");
const native_1 = require("@react-navigation/native");
const { Navigator, Screen } = (0, drawer_1.createDrawerNavigator)();
const pickRouteIcon = (routeName, isActive) => {
    const iconColor = (0, react_1.useMemo)(() => (isActive ? colors_1.Colors.PRIMARY_300 : 'white'), [isActive]);
    switch (routeName) {
        case 'Discover':
            return (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCompass, color: iconColor, size: 20 });
        case 'Characters':
            return (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faUsers, color: iconColor, size: 26 });
        case 'Chats':
            return (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faComments, color: iconColor, size: 26 });
        case 'Documents':
            return (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faBookOpenCover, color: iconColor, size: 26 });
        case 'Library':
            return (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faBooks, color: iconColor, size: 26 });
        case 'Account':
            return (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faUser, color: iconColor, size: 20 });
    }
    ;
};
const Drawer = (props) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { signOutAppState } = (0, useAppState_1.useAppState)();
    const isUserLogged = (0, react_redux_1.useSelector)(user_1.selectIsUserLogged);
    const navigation = (0, native_1.useNavigation)();
    const currentRoute = (0, react_1.useMemo)(() => (props.state.routes[props.state.index]), [props]);
    return ((0, jsx_runtime_1.jsxs)(drawer_1.DrawerContentScrollView, { ...props, contentContainerStyle: styles.container, children: [(0, jsx_runtime_1.jsx)(native_base_1.Divider, { backgroundColor: colors_1.Colors.PRIMARY_700 }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.menuContainer, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.menu, children: props.state.routes.map((route) => ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: () => props.navigation.navigate(route.name), style: styles.item, children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.icon, children: pickRouteIcon(route.name, route.key === currentRoute.key) }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: route.key === currentRoute.key ? colors_1.Colors.PRIMARY_300 : 'white', fontSize: 20, fontWeight: 500, display: "flex", alignItems: "center", children: route.name })] }) }))) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.menu, styles.subMenu], children: isUserLogged ? ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: () => isUserLogged ? signOutAppState() : navigation.navigate('LoginPage'), style: styles.item, children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.icon, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faArrowRightToBracket, color: "white", size: 20 }) }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: "white", fontSize: 20, fontWeight: 500, display: "flex", alignItems: "center", children: isUserLogged ? "Log Out" : "Login" })] }) })) : ((0, jsx_runtime_1.jsx)(AppButton_1.PrimaryButton, { onPress: () => navigation.navigate('LoginPage'), children: "Login" })) })] })] }));
};
function DiscoverDrawer() {
    const { width: VW } = (0, react_native_1.useWindowDimensions)();
    return ((0, jsx_runtime_1.jsxs)(Navigator, { useLegacyImplementation: false, screenOptions: {
            headerShown: false,
            drawerStyle: [styles.drawer, { width: VW * 0.75 }],
            // percentual width property makes drawer starts opened
        }, drawerContent: Drawer, children: [(0, jsx_runtime_1.jsx)(Screen, { name: "Documents", component: Documents_1.default }), (0, jsx_runtime_1.jsx)(Screen, { name: "Chats", component: AllCharacterList_1.default }), (0, jsx_runtime_1.jsx)(Screen, { name: "Library", component: Library_1.default }), (0, jsx_runtime_1.jsx)(Screen, { name: "Account", component: DiscoverProfile_1.DiscoverProfile })] }));
}
;
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
    },
    drawer: {
        backgroundColor: colors_1.Colors.DARK_700,
        paddingHorizontal: 20,
    },
    menuContainer: {
        justifyContent: 'space-between',
        flex: 1,
    },
    menu: {
        gap: 32,
        marginTop: 24,
    },
    item: {
        gap: 7,
        flexDirection: 'row',
    },
    icon: {
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: 32,
        minHeight: 32,
    },
    subMenu: {
        marginBottom: 42,
    },
});
